import {Component} from '@angular/core';
import {DynamicComponentBaseComponent} from '../../../../../dynamic-components/components/dynamic-component-base/dynamic-component-base.component';
import {UploadedRowPart} from '../../../../interfaces/forms/file-upload';

@Component({
    selector: 'app-upload-name',
    templateUrl: './upload-name.component.html',
    styleUrls: ['./upload-name.component.scss'],
    standalone: false
})
export class UploadNameComponent extends DynamicComponentBaseComponent<UploadedRowPart> {}
